import { format as dateFormat } from 'date-fns';
import { TIME_ZONE_FORMAT } from '@/constants/dateFormats';

export const formatDate = (timestamp: string, format?: string) => {
  const date = new Date(timestamp);
  return dateFormat(date, format ? format : TIME_ZONE_FORMAT);
};
